import { render, staticRenderFns } from "./DealerEditDialog.vue?vue&type=template&id=c2f3ed1c"
import script from "./DealerEditDialog.vue?vue&type=script&lang=js"
export * from "./DealerEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports